import { z } from 'zod';

// Betraege koennen je nach Quelle als String (DECIMAL aus MySQL, str() im
// Backend) oder als Zahl ankommen — lenient annehmen.
const moneyish = z.union([z.string(), z.number()]).nullable().optional();

export const AccountTransactionSchema = z.object({
  BookingDate: z.string().nullable().optional(),
  ValutaDate: z.string().nullable().optional(),
  Amount: moneyish,
  Currency: z.string().nullable().optional(),
  Purpose: z.string().nullable().optional(),
  Applicant: z.string().nullable().optional(),
});

export const AccountTrackingListItemSchema = z.object({
  idProcessManager: z.number().int(),
  idLegalTransaction: z.number().int().nullable(),
  IBAN: z.string().nullable().optional(),
  BankName: z.string().nullable().optional(),
  TargetAmount: moneyish,
  CurrentBalance: moneyish,
  TargetReachedAt: z.string().nullable().optional(),
  LastCheckedAt: z.string().nullable().optional(),
  BalanceChangeMode: z.string().nullable().optional(),
  BalanceChangeFiredAt: z.string().nullable().optional(),
  TransactionCount: z.number().int().default(0),
});

export const AccountTrackingSchema = AccountTrackingListItemSchema.extend({
  idLegalClient: z.number().int().optional(),
  Transactions: z.array(AccountTransactionSchema).default([]),
});

export type IAccountTransaction = z.infer<typeof AccountTransactionSchema>;
export type IAccountTrackingListItem = z.infer<
  typeof AccountTrackingListItemSchema
>;
export type IAccountTracking = z.infer<typeof AccountTrackingSchema>;
